import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import crm, { apiErr } from "../crmApi";
import { Loader } from "../CrmApp";

const ACTION = {
  created: ["Created", "bg-pbs-purple/10 text-pbs-purple"], draft_saved: ["Draft saved", "bg-pbs-orange/15 text-pbs-orange"],
  draft_discarded: ["Draft discarded", "bg-pbs-grey/15 text-pbs-grey"], published: ["Published", "bg-green-100 text-green-700"],
  unpublished: ["Unpublished", "bg-pbs-coral/10 text-pbs-coral"], deleted: ["Deleted", "bg-pbs-coral/20 text-pbs-coral"],
  featured: ["Featured", "bg-pbs-gold/20 text-pbs-plum"], unfeatured: ["Unfeatured", "bg-pbs-grey/15 text-pbs-grey"],
};
const val = (v) => (v === null || v === undefined || v === "" ? "—" : typeof v === "string" && v.length > 60 ? `${v.slice(0, 60)}…` : String(v));

export function HistoryList({ items }) {
  if (items.length === 0) return <p className="p-6 text-sm text-pbs-grey">No changes recorded yet.</p>;
  return (
    <div className="divide-y divide-pbs-line/60" data-testid="wm-history-list">
      {items.map((h) => {
        const [label, cls] = ACTION[h.action] || [h.action, "bg-pbs-bg text-pbs-grey"];
        return (
          <details key={h.id} className="px-4 py-3 group">
            <summary className="flex items-center gap-2 flex-wrap cursor-pointer list-none">
              <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${cls}`}>{label}</span>
              <Link to={`/crm/website/edit/${h.property_id}`} className="text-sm font-semibold text-pbs-dark hover:text-pbs-purple">{h.property_name}</Link>
              <span className="text-xs text-pbs-grey">by {h.user_name} ({h.user_role.replace("_", " ")}) · {new Date(h.at).toLocaleString("en-IN")}</span>
              {h.note && <span className="text-xs font-mono text-pbs-grey">{h.note}</span>}
              {h.changes?.length > 0 && <span className="text-xs text-pbs-purple ml-auto">{h.changes.length} field(s) ▾</span>}
            </summary>
            {h.changes?.length > 0 && (
              <table className="mt-2 w-full text-xs"><tbody>
                {h.changes.map((c, i) => <tr key={i} className="border-t border-pbs-line/50"><td className="py-1 pr-3 font-semibold text-pbs-dark w-40">{c.field}</td><td className="py-1 pr-3 text-pbs-coral line-through">{val(c.from)}</td><td className="py-1 text-green-700">{val(c.to)}</td></tr>)}
              </tbody></table>
            )}
          </details>
        );
      })}
    </div>
  );
}

export default function WmHistory() {
  const [items, setItems] = useState(null);
  useEffect(() => { crm.wm.history().then(setItems).catch((e) => { toast.error(apiErr(e)); setItems([]); }); }, []);
  if (!items) return <Loader />;
  return <div className="crm-card"><h3 className="font-bold text-pbs-dark px-4 pt-4 pb-2">Change History</h3><HistoryList items={items} /></div>;
}
